import React from 'react';
import {
  Form,
  Input,
  Button,
  Icon,
  Alert,
  Modal
} from 'antd';
const FormItem = Form.Item;

class UserChangePasswordModalForm extends React.Component {
  state = {
    confirmDirty: false,
    error: ""
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error !== this.props.error) {
      this.setState({error: nextProps.error})
    }
  }

  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('newPassword')) {
      callback('Nhập lại mật khẩu không khớp!');
    } else {
      callback();
    }
  }

  checkConflict = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value === form.getFieldValue('password')) {
      callback('Mật khẩu mới phải khác mật khẩu cũ!');
    } else {
      callback();
    }
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({
      confirmDirty: this.state.confirmDirty || !!value,
      error: ''
    });
  }

  resetError = () => {
    this.setState({error: ""})
  }

  render() {
    const {fetching, visible, onCancel, onSubmit, form} = this.props;
    const {getFieldDecorator} = form;
    const errorElement = this.state.error
      ? <Alert type="error" message={this.state.error} banner="banner"/>
      : null;
    return (<Modal visible={visible} title="Đổi mật khẩu" width={480} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
        <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
        <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
          Lưu
        </Button>
      ]} className="modal-form">
      {errorElement}
      <Form onSubmit={onSubmit}>
        <FormItem>
          {
            getFieldDecorator('password', {
              rules: [
                {
                  required: true,
                  message: 'Phải nhập mật khẩu cũ!'
                }
              ]
            })(<Input type="password" placeholder='mật khẩu cũ' onChange={this.resetError}/>)
          }
        </FormItem>
        <FormItem>
          {
            getFieldDecorator('newPassword', {
              rules: [
                {
                  required: true,
                  message: 'Phải nhập mật khẩu mới!'
                }, {
                  validator: this.checkConflict
                }
              ]
            })(<Input type="password" placeholder='mật khẩu mới' onChange={this.resetError}/>)
          }
        </FormItem>
        <FormItem hasFeedback={true}>
          {
            getFieldDecorator('confirmNewPassword', {
              rules: [
                {
                  required: true,
                  message: 'Phải nhập lại mật khẩu mới!'
                }, {
                  validator: this.checkPassword
                }
              ]
            })(<Input type="password" placeholder='nhập lại mật khẩu mới' onBlur={this.handleConfirmBlur} onChange={this.resetError}/>)
          }
        </FormItem>
      </Form>
    </Modal>);
  }
}

export default Form.create()(UserChangePasswordModalForm)



// WEBPACK FOOTER //
// ./src/components/UserChangePasswordModalForm.js